/** Node types we never show Remix for. */
export const REMIX_DENY_LIST_V1: readonly string[] = [
	'mediaSingle',
	'mediaGroup',
	'media',
	'image',
	'extension',
	'bodiedExtension',
	'multiBodiedExtension',
	'embedCard',
	'blockCard',
	'inlineCard',
	// Source blocks
	'bodiedSyncBlock',
	// Reference blocks
	'syncBlock',
	'expand',
	'nestedExpand',
] as const;

const DENY_SET = new Set<string>(REMIX_DENY_LIST_V1);

/** True if this node type is in the remix deny list (restricted). */
export const isRemixRestrictedNodeType = (nodeType: string): boolean => DENY_SET.has(nodeType);

/** Node types that stay in the deny list but are remixable through `isRemixRestrictedNodeTypeWithExpands`. */
export const REMIX_EXPAND_NODE_TYPES: readonly string[] = ['expand', 'nestedExpand'] as const;

const EXPAND_NODE_TYPES = new Set<string>(REMIX_EXPAND_NODE_TYPES);

/**
 * Deny-list check that additionally allows expands.
 *
 * Expands stay in `REMIX_DENY_LIST_V1` so `isRemixRestrictedNodeType` and every caller that
 * relies on the shared default keep their current behaviour. Only callers that opt in via this
 * function see expands as supported.
 */
export const isRemixRestrictedNodeTypeWithExpands = (nodeType: string): boolean => {
	if (EXPAND_NODE_TYPES.has(nodeType)) {
		return false;
	}
	return isRemixRestrictedNodeType(nodeType);
};

/**
 * True if the given extension key is in the provided allow list.
 *
 * The allow list is passed in by the consumer (e.g. Confluence) so that
 * feature-flag checks and product-specific decisions stay outside platform
 * code.
 */
export const isAllowedMBEExtensionForRemix = (
	extensionKey: string | undefined,
	allowList: ReadonlyArray<string>,
): boolean => extensionKey !== undefined && allowList.includes(extensionKey);
